import Vue from "vue";
import VueRouter from "vue-router";
import LoginComponent from "@/components/login/login.component.vue";
import ForgotPasswordComponent from "@/components/forgot-password/forgot-password.component";
import LogoutComponent from "@/components/logout/logout.component";
import HomeComponent from "@/components/home/home.vue";
import DashboardComponent from "@/components/home/dashboard.vue";
import OfficeComponent from "@/components/home/office/office.vue";
import CustomersListComponent from "@/components/home/office/customers-list.vue";
import CustomerFormComponent from "@/components/home/office/customer-form.vue";
import WorkOrdersListComponent from "@/components/home/office/work-orders-list.vue";
import WorkOrderFormComponent from "@/components/home/office/work-order-form.vue";
import UsersComponent from "@/components/home/users/users.vue";
import UserFormComponent from "@/components/home/users/user-form/user-form.vue";
import ShopManagerComponent from "@/components/home/shop-manager.vue";
import TechnicianComponent from "@/components/home/technician.vue";
import InvoicesComponent from "@/components/home/invoices/invoices.vue";
import InvoicesControllerComponent from "@/components/home/invoices/invoices-controller.vue";
import InvoiceFormComponent from "@/components/home/invoices/invoice-form.vue";
import InvoiceDetailsComponent from "@/components/home/invoices/invoice-details.vue";
import ReportsHome from "@/components/home/reports/reports-home.vue";
import SigTester from "@/components/common/signa/SigTester.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    redirect: "login",
  },
  {
    path: "/signa",
    name: "signa",
    component: SigTester,
  },
  {
    path: "/login",
    name: "login",
    component: LoginComponent,
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPasswordComponent,
  },
  {
    path: "/logout",
    name: "logout",
    component: LogoutComponent,
  },
  {
    path: "/",
    name: "Home",
    component: HomeComponent,
    children: [
      {
        path: "",
        redirect: "dashboard",
      },
      {
        path: "dashboard",
        name: "dashboard",
        component: DashboardComponent,
      },
      {
        path: "office",
        name: "office",
        component: OfficeComponent,
      },
      {
        path: "office/customers",
        name: "customers",
        component: CustomersListComponent,
				meta: { keepAlive: true }, 
      },
      {
        path: "office/customers/add",
        name: "customers-add",
        component: CustomerFormComponent,
      },
      {
        path: "office/customers/edit/:id",
        name: "customers-edit",
        component: CustomerFormComponent,
      },
      {
        path: "office/work-orders",
        name: "office-work-order",
        component: WorkOrdersListComponent,
      },
      {
        path: ":type/work-order/add/:customerId?",
        name: "work-order-add",
				meta: {
					IsCreating: true,
				},
        component: WorkOrderFormComponent,
      },
      {
        path: ":type/work-order/edit/:id/:customerId",
        name: "work-order-edit",
				meta: {
					IsEditing: true,
				},
        component: WorkOrderFormComponent,
      },
      {
        path: ":type/work-order/view/:id",
				name: "work-order-view",
				meta: {
					IsViewing: true,
				},
        component: WorkOrderFormComponent,
      },
      {
        path: "users",
        name: "users",
        component: UsersComponent,
				meta: { keepAlive: true }				
      },
      {
        path: "users/add",
        name: "users-add",
        component: UserFormComponent,
      },
      {
        path: "users/edit/:id",
        name: "users-edit",
        component: UserFormComponent,
      },
      {
        path: "shop-manager",
        name: "shop-manager",
        component: ShopManagerComponent,
      },
      {
        path: "technician",
        name: "technician",
        component: TechnicianComponent,
      },
      {
        path: "invoices",
				name: "invoices",
				meta: {
					IsController: false,
					keepAlive: true,
				},
        component: InvoicesControllerComponent,
      },
      // {
      //   path: "invoices/add",
      //   name: "invoices-add",
      //   component: InvoiceFormComponent,
      // },
      {
        path: "invoices/edit/:id",
        name: "invoices-edit",
        component: InvoiceFormComponent,
      },
      {
        path: "invoices/:id",
				name: "invoices-details",
				meta:{
					IsController: false,
				},
        component: InvoiceDetailsComponent,
			},
			
			
      {
        path: "invoices-controller",
				name: "invoices-controller",
				meta: {
					IsController: true,
					keepAlive: true,				
				},
        component: InvoicesControllerComponent,
      },
      {
        path: "invoices-controller/edit/:id",
        name: "invoices-controller-edit",
        component: InvoiceFormComponent,
			},
      {
        path: "invoices-controller/:id",
				name: "invoices-details",
				meta:{
					IsController: true,
				},
        component: InvoiceDetailsComponent,
			},
			
      {
        path: "reports",
				name: "technician-reports",
        component: ReportsHome,
			},
			

		],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
